import 'element-plus/dist/index.css'; // 引入 Element Plus 的样式
import ElementPlus from "element-plus";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'; // 引入中文语言包
import * as elementIcons from '@element-plus/icons-vue'; // 引入element自带的icon库


function install(app, options = {}) {
  // 注册全局组件，配置中文语言
  app.use(ElementPlus, {
    locale: zhCn,
  })

  // 注册icons组件
  for (const key in elementIcons) {
    const iconComp = elementIcons[key];
    app.component(iconComp.name, iconComp);
  }

}


export default { install };
